import React from "react";
import Header from "../components/Header";
import heroBg from "../assets/herobg1.png";

export default function TermsOfService() {
  return (
    <main className="min-h-screen bg-[#FBF1EB]">
      <Header />

              <div className="relative w-full h-[350px] sm:h-[300px] overflow-hidden">
        <img
          src={heroBg}
          alt="Export Hero Image"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <section className="w-full py-16 px-4 md:px-12 lg:px-24 bg-[#FBF1EB]">
        <h1 className="text-3xl font-bold mb-4">Terms of Service</h1>

        <p className="mb-4">
          These Terms of Service govern your access to and use of the website and services offered by Synergy Innovative Enterprises, a global exporter of Spices, Dehydrated Fried Onions, Onion Powder, and other food products.
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-2">1. Our Services</h2>
        <p className="mb-4">
          We provide export solutions to international buyers, wholesalers, food processing companies, and restaurant chains. All services are provided subject to the terms outlined herein.
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-2">2. Product Availability & Accuracy</h2>
        <p className="mb-4">
          Product specifications and availability may vary by region and season. While we aim to maintain accuracy, users should verify details directly with our sales team before making procurement decisions.
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-2">3. Quotations & Orders</h2>
        <ul className="list-disc list-inside mb-4">
          <li>All orders require a formal inquiry and confirmation process.</li>
          <li>Pricing, delivery schedules, and terms are detailed in the proforma invoice.</li>
          <li>Custom orders may involve longer lead times or adjusted pricing.</li>
        </ul>

        <h2 className="text-xl font-semibold mt-6 mb-2">4. Payment Terms</h2>
        <p className="mb-4">
          Payment methods and timelines are mutually agreed upon per transaction. Delayed payments may affect delivery schedules. We accept bank transfers, LC, and other globally accepted payment modes.
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-2">5. Shipping & Liability</h2>
        <p className="mb-4">
          We ensure secure packaging and trusted logistics. However, once the goods are handed over to shipping partners, delays or damages beyond our control are not our liability unless agreed otherwise.
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-2">6. Intellectual Property</h2>
        <p className="mb-4">
          All content, product names, and branding elements on this site are property of Synergy Innovative Enterprises and cannot be reproduced without permission.
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-2">7. Modifications</h2>
        <p className="mb-4">
          We may update these Terms from time to time. Continued use of the website indicates acceptance of the latest version.
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-2">8. Governing Law</h2>
        <p className="mb-4">
          These Terms shall be governed by the laws of India. Any disputes will be subject to the jurisdiction of the courts in [Your Business City].
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-2">9. Contact Us</h2>
        <p className="mb-4">
          For queries or concerns regarding our Terms of Service, please contact:
        </p>
        <p className="mb-1">📧 Email: info@synergyexports.com</p>
          <a href="tel:+919356936283" className="mb-1">
                 📞 +91 9356936283
                </a>
        <p className="mb-1">🌐 Website: www.synergyexports.com</p>
      </section>
    </main>
  );
}
